/**
 * localStorage envuelto.
 *
 * En una ventana privada de Safari, y con las cookies de terceros
 * bloqueadas en algunos navegadores, el solo hecho de LEER
 * `window.localStorage` tira una excepción. Si eso pasa arriba del árbol de
 * React, la pantalla queda en blanco por haber querido recordar el idioma.
 * Acá cualquier fallo se traduce en "no había nada guardado".
 */
export function readStored(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writeStored(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // Sin persistencia: la preferencia vale para esta sesión y ya.
  }
}
